import { createApi } from "@reduxjs/toolkit/query/react";
import { WebClient } from "../axios_api";

const webClientBaseQuery =
  () =>
  async ({ url, method, body, headers = {} }) => {
    try {
      let data;
      switch (method) {
        case "POST":
          data = await WebClient.post(url, headers, body);
          return { data };

        case "PUT":
          data = await WebClient.put(url, headers, body);
          return { data };

        case "DELETE":
          data = await WebClient.delete(url, headers, body);
          return { data };

        default:
          data = await WebClient.get(url);
          return { data };
      }
    } catch (error) {
      return { error };
    }
  };

export const baseApiConfig = createApi({
  baseQuery: webClientBaseQuery(), // fetchBaseQuery({ baseUrl: "/"}),
  endpoints: () => ({})
});
